export const SITE_URL = "https://www.mknprojects.com";

export const SEO_PAGES = {
  "/": {
    fr: {
      title: "MKN Projects | Gestion de projets & Business Development",
      description:
        "MKN Projects accompagne entreprises et organisations en gestion de projets, Program Management et Business Development dans l'aéronautique, la défense, l'industrie, les technologies et l'énergie.",
      ogTitle: "MKN Projects — Piloter. Développer. Transformer.",
      ogDescription:
        "Gestion de projets, Business Development et solutions digitales pour des environnements industriels et technologiques complexes.",
      locale: "fr_FR",
    },
    en: {
      title: "MKN Projects | Project Management & Business Development",
      description:
        "MKN Projects supports companies and organisations in project management, program management and business development across aerospace, defence, industry, technology and energy.",
      ogTitle: "MKN Projects — Pilot. Develop. Transform.",
      ogDescription:
        "Project management, business development and digital solutions for complex industrial and technological environments.",
      locale: "en_GB",
    },
  },
  "/gestion-de-projets": {
    fr: {
      title: "Gestion de projets industriels & Program Management | MKN Projects",
      description:
        "Conseil en gestion de projets et programmes industriels : cadrage, gouvernance, pilotage coûts-qualité-délais, risques, interfaces et fournisseurs. Expertise certifiée PMP® en aéronautique, défense, industrie et énergie.",
      ogTitle: "Gestion de projets & programmes industriels — MKN Projects",
      ogDescription:
        "Renforcer ou prendre en charge le pilotage de projets et programmes complexes, du cadrage à la livraison.",
      locale: "fr_FR",
    },
    en: {
      title: "Industrial Project & Program Management | MKN Projects",
      description:
        "Industrial project and programme management consulting: framing, governance, cost-quality-schedule control, risks, interfaces and suppliers. PMP®-certified expertise in aerospace, defence, industry and energy.",
      ogTitle: "Industrial project & programme management — MKN Projects",
      ogDescription:
        "Reinforcing or taking charge of the management of complex projects and programmes, from framing to delivery.",
      locale: "en_GB",
    },
  },
  "/aeronautique-defense": {
    fr: {
      title: "Gestion de projets aéronautique & défense | MKN Projects",
      description:
        "Pilotage de projets et programmes aéronautiques et de défense : systèmes embarqués, équipements avioniques, communications pour aéronefs, intégration de systèmes, coordination logiciel / matériel. Plus de dix ans d'expérience.",
      ogTitle: "Gestion de projets aéronautique & défense — MKN Projects",
      ogDescription:
        "Secteur historique de MKN Projects : plus de dix années de pilotage de systèmes embarqués, avioniques et de communication pour plateformes aériennes.",
      locale: "fr_FR",
    },
    en: {
      title: "Aerospace & Defence Project Management | MKN Projects",
      description:
        "Management of aerospace and defence projects and programmes: embedded systems, avionics equipment, aircraft communications, systems integration, software / hardware coordination. Over ten years of experience.",
      ogTitle: "Aerospace & defence project management — MKN Projects",
      ogDescription:
        "MKN Projects' historical sector: more than ten years managing embedded, avionics and communication systems for aerial platforms.",
      locale: "en_GB",
    },
  },
};

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export function applySeo(lang, path = "/") {
  const page = SEO_PAGES[path] || SEO_PAGES["/"];
  const s = page[lang];
  const url = `${SITE_URL}${SEO_PAGES[path] ? path : "/"}`;
  document.documentElement.lang = lang;
  document.title = s.title;
  setLink("canonical", url);
  setMeta("property", "og:url", url);
  setMeta("name", "description", s.description);
  setMeta("property", "og:title", s.ogTitle);
  setMeta("property", "og:description", s.ogDescription);
  setMeta("property", "og:locale", s.locale);
  setMeta("name", "twitter:title", s.ogTitle);
  setMeta("name", "twitter:description", s.ogDescription);
}

export function initAnalytics() {
  const gscToken = process.env.REACT_APP_GSC_VERIFICATION;
  if (gscToken) setMeta("name", "google-site-verification", gscToken);

  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!gaId || window.gtag) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", gaId, { anonymize_ip: true });
}
